import React from 'react';
import PropTypes from 'prop-types';
import ListDetailsDrinks from '../components/ListDetailsDrinks';
import FinishButton from '../components/FinishButton';
import BackButton from '../components/BackButton';

function DrinksProgress(props) {
  const { match: { params: { id } } } = props;
  const { location: { pathname } } = props;
  return (
    <div className="d-progress">
      <BackButton />
      <ListDetailsDrinks id={ id } pathname={ pathname } />
      <FinishButton id={ id } type="drink" />
    </div>
  );
}

DrinksProgress.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string }).isRequired,
};

export default DrinksProgress;
